import React from "react";
import PropTypes from "prop-types";

import { CardBox, Centered, RightCornerIcon, SplitPanel } from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import CalendarIcon from "../../Icons/CalendarIcon";
import StatusIcon from "../../Icons/StatusIcon";
import CardCore from "../CardCore";
import ShowComments from "../Global/ShowComments";
import RescheduleButton from "../Global/Reschedule";
import AddCalendar from "components/AddCalendar";

const serviceNotificationCategory = "contractor_appointment_confirmed";

export const ServiceNotification = ({
  description,
  providerName,
  enableComments,
  moreInformation,
  showRescheduleButton,
  rawEventDate
}) => {
  const t = useTranslate();
  const showComments = enableComments && moreInformation === null;
  const isAppointmentInTheFuture =
    new Date(rawEventDate) > new Date(Date.now());
  return (
    <CardBox data-category={serviceNotificationCategory}>
      <SplitPanel>
        <Centered>
          <RightCornerIcon>
            <StatusIcon status="SAVED" />
          </RightCornerIcon>
          <CalendarIcon />
        </Centered>
        <CardCore
          title={t("service_notification_card-title")}
          additionalDescription={`${t(
            "service_notification_card-text_1"
          )} ${providerName} ${t("service_notification_card-text_2")}`}
          description={description}
          rawEventDate={rawEventDate}
          statusClass="success"
        />
        {isAppointmentInTheFuture && <AddCalendar />}
      </SplitPanel>
      {showComments && <ShowComments />}
      {showRescheduleButton && isAppointmentInTheFuture && <RescheduleButton />}
    </CardBox>
  );
};

ServiceNotification.propTypes = {
  description: PropTypes.string.isRequired,
  rawEventDate: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired
};

export default ServiceNotification;
